import { useCallback, useRef } from 'react';

/**
 * Custom hook for Web Speech API text-to-speech.
 * Usage: const { speak, stop, speaking } = useTTS();
 */
export default function useTTS() {
  const speakingRef = useRef(false);

  const speak = useCallback((text, lang = 'en-GB', rate = 0.85) => {
    if (!window.speechSynthesis || !text) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang;
    utterance.rate = rate;
    utterance.onstart = () => { speakingRef.current = true; };
    utterance.onend = () => { speakingRef.current = false; };
    utterance.onerror = () => { speakingRef.current = false; };
    window.speechSynthesis.speak(utterance);
  }, []);

  const stop = useCallback(() => {
    if (window.speechSynthesis) window.speechSynthesis.cancel();
    speakingRef.current = false;
  }, []);

  return { speak, stop, speaking: speakingRef };
}
